import { gsap } from "gsap";
import React, { useEffect, useRef, useState } from "react";
import beyondImg from "./images/img-beyond.png";
import "./beyond.css";

export default function Beyond() {
  return (
    <div className="beyond-wrapper">
      <section className="section1 beyond">
        <div className="beyond-container">
          <div className="beyond-content">
            <div className="beyond-text">
              <p>Versatilitate și minimalism.</p>
              <p>O vară de posibilități</p>
              <p>infinite</p>
            </div>
            <div className="cta-colectie mobile-erase">
              {" "}
              <a
                href={
                  "https://www.teilor.ro/urbanima/filtre/tipbijuterie-inel.html"
                }
              >
                <div className="button1"> VEZI TOATA COLECTIA URBANIMA </div>
              </a>
            </div>
            <div className="col-1 mobile-reveal">
              <div className="cta-colectie">
                {" "}
                <a href="https://www.teilor.ro/urbanima/filtre/tipbijuterie-inel.html">
                  <div className="button1"> VEZI TOATA COLECTIA URBANIMA </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
